import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from '../store/auth.store';

export const authGuard: CanActivateFn = (_, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated() && authStore.user()) {
    return true;
  }

  void router.navigate(['/auth/login'], {
    queryParams: { returnUrl: state.url },
  });
  return false;
};
